import { constants } from "shared/constants";
import { CompanyBasedSectionReports } from "./CompanyBasedSectionReports";

const salesAndActivitySectionReports = [
    constants.v360ReportCodes.intermediary.salesAndActivitySection.sales,
    constants.v360ReportCodes.intermediary.salesAndActivitySection.activity,
    constants.v360ReportCodes.salesPerson.salesAndActivitySection.sales,
    constants.v360ReportCodes.salesPerson.salesAndActivitySection.activity,
];

const salesAndActivitySectionPatternReports = [
    constants.v360ReportCodes.intermediary.salesAndActivitySection.sales,
    constants.v360ReportCodes.salesPerson.salesAndActivitySection.sales,
];

class SalesAndActivitySectionReports extends CompanyBasedSectionReports {
    /**
     *
     */
    constructor() {
        super(salesAndActivitySectionReports, salesAndActivitySectionPatternReports);
    }
}

export default new SalesAndActivitySectionReports();
